/**
 * Timeouts for the chat pipeline. All values in milliseconds.
 *
 * These convert silent network/server hangs into thrown `AbortError`s so
 * the UI can recover (either via existing retry logic or a safe fallback)
 * instead of leaving the user watching the three typing dots forever.
 *
 * Kept in one file so they're easy to tune.
 */

/** Time allowed for the main chat fetch to return its first byte. */
export const CHAT_CONNECTION_TIMEOUT_MS = 25_000;

/**
 * Max gap between SSE chunks once streaming has started.
 *
 * Set to 90s to accommodate image-generation tool calls (Imagen 4 Ultra,
 * Gemini 3 Pro Image, GPT Image 1.5 high) which naturally produce a long
 * silent gap between the model's tool-call chunk and the resulting
 * `imageGenerated` chunk — typically 15-30s warm, occasionally 60s+ cold.
 * Pure text chat responses still stream chunks every few hundred ms, so this
 * only delays detection of truly hung requests, never healthy ones.
 */
export const CHAT_STREAM_STALL_TIMEOUT_MS = 90_000;

/** Safety check — fails open (no violations) on timeout. */
export const SAFETY_CHECK_TIMEOUT_MS = 13_000;

/** Intent detection — fails open (no feature hints) on timeout. */
export const INTENT_DETECTION_TIMEOUT_MS = 11_000;

/** Context-window summarization — falls back to unsummarized context on timeout. */
export const SUMMARIZATION_TIMEOUT_MS = 20_000;

/** Pre-fetched web search — skipped silently on timeout. */
export const WEB_SEARCH_TIMEOUT_MS = 17_000;
